import { FileReportSendResponseViewModel } from '../../../types';

const mockFileReportSendResponseSuccess: FileReportSendResponseViewModel = [
  {
    fileReportUploadUid: '1234',
    errorMessage: '',
    success: true,
    refId: '34857349',
    reportDate: '2024-02-28',
    source: 'Visma',
    friendlyErrorMessage: '',
  },
  {
    fileReportUploadUid: '12345',
    errorMessage: '',
    success: true,
    refId: '34857348',
    reportDate: '2024-02-27',
    source: 'Visma',
    friendlyErrorMessage: '',
  },
];

const mockFileReportSendResponseWithError: FileReportSendResponseViewModel = [
  {
    fileReportUploadUid: '1234',
    errorMessage: '"Request error (Bad Request)"',
    success: false,
    refId: '39485739845',
    reportDate: '2024-02-28',
    source: 'Visma',
    friendlyErrorMessage: '',
  },
  {
    fileReportUploadUid: '12345',
    errorMessage: '',
    success: true,
    refId: '34857348',
    reportDate: '2024-02-27',
    source: 'Visma',
    friendlyErrorMessage: '',
  },
];

export const mockFileReportSendResponse = {
  success: mockFileReportSendResponseSuccess,
  withError: mockFileReportSendResponseWithError,
};
